<template>

  <main class="content content--narrow" v-if="typeof user.uuid !== 'undefined'">
    <figure class="content__avatar content__avatar--company">
      <!--      <img v-if="form.logo !== false && picImage === ''" :src="form.logo">-->
      <img v-if="picImage !== ''" :src="picImage"/>
      <button class="content__avatar__upload" @click="openFilePicker()"></button>
    </figure>

    <div class="content__heading content__heading--center">
      <h1>
        <i class="icon--company"></i> {{ user.company.name }}
      </h1>
    </div>

    <section class="content--boxed">
      <ValidationObserver ref="form" v-slot="{ invalid }" tag="form" class="form__wrapper grid__col&#45;&#45;width-md-5"
                          @keyup.enter="submitForm()">
        <div class="field__row hidden">
          <FileInput @picChanged="picImage = $event" name="logo" accept="image/*" id="uploadAvatar" ref="fileInput"
                     select-label="general.select_image"
                     @input="getUploadedFile"
                     :model="form.profile_pic"
                     :value="form.profile_pic">
          </FileInput>
        </div>
        <div class="field__row">
          <Field :label="$t('company.name')" name="name" rules="required|max:255" type="text" v-model="form.name"/>
        </div>
        <div class="field__row">
          <Field :label="$t('company.address')" name="address" rules="required|max:255" type="text"
                 v-model="form.address"/>
        </div>
        <div class="field__row">
          <Field :label="$t('company.city')" name="city" rules="required|max:255" type="text"
                 v-model="form.city"/>
        </div>
        <div class="field__row">
          <Field :label="$t('company.postalCode')" name="postal_code" rules="required|max:20" type="text"
                 v-model="form.postal_code"/>
        </div>
        <div class="field__row">
          <Field :label="$t('company.mobile')" name="mobile" rules="required|max:255" type="text"
                 v-model="form.mobile"/>
        </div>
        <div v-if="has_vat" class="field__row">
          <Field :label="$t('company.vat')" name="vat" rules="max:255" type="text"
                 v-model="form.vat" :required="false"/>
        </div>
        <div class="field__row">
          <FieldSelect :label="$t('general.country')"
                       name="country"
                       :items="countryList"
                       rules="required"
                       label-key="name"
                       value-key="code"
                       :placeholder="$t('general.country_select')"
                       v-model="form.country_code"/>
        </div>
        <div class="field__row">
          <FieldSelect :label="$t('company.language')" name="language_code" :items="languages" rules=""
                       label-key="title"
                       value-key="value"
                       :placeholder="$t('company.language_select')"
                       v-model="form.language_code"/>
          <small class="hint">{{ $t('company.languageHint') }}</small>
        </div>
        <div class="field__row">
          <TextareaField :label="$t('company.emailBody')"
                         name="pre_email_body"
                         rules=""
                         type="text"
                         v-model="form.pre_email_body">
            <template v-slot:helper-text>
            </template>
            <template v-slot:hint>
              <small class="hint">{{ $t('company.emailBodyHint') }}</small>
            </template>
          </TextareaField>
        </div>

        <div class="btn--bar">
          <button class="btn btn--center" type="button" @click="submitForm()" :disabled="invalid || submit">
            <i class="icon--check"></i> {{ $t('general.save_changes') }}
          </button>
        </div>

      </ValidationObserver>
    </section>
  </main>
</template>

<script>
import FileInput from '@/components/FileInput'
import Field from '@/components/Parts/Field'
import { errHandler } from '@/helpers'
import TextareaField from '@/components/Parts/Textarea'
import FieldSelect from '@/components/Parts/FieldSelect'
import { isEU } from '@/util'

export default {
  name: 'Company-Index',
  components: {
    Field,
    FileInput,
    TextareaField,
    FieldSelect
  },
  mounted () {
    this.init()
  },
  data: function () {
    return {
      form: {
        name: '',
        address: '',
        city: '',
        postal_code: '',
        mobile: '',
        vat: '',
        language_code: '',
        logo: '',
        pre_email_body: '',
        country_code: ''
      },
      has_vat: false,
      submit: false,
      picImage: '',
      changeImage: false,
      countryList: []
    }
  },
  computed: {
    languages () {
      return this.$store.getters['language/list']
    }
  },
  methods: {
    async init () {
      try {
        this.form = {
          name: this.user.company.name,
          address: this.user.company.address,
          city: this.user.company.city,
          postal_code: this.user.company.postal_code,
          mobile: this.user.company.mobile,
          logo: this.user.company.logo,
          pre_email_body: this.user.company.pre_email_body,
          vat: this.user.company.vat,
          language_code: this.user.company.language_code,
          country_code: this.user.company.country_code
        }
        this.has_vat = isEU(this.form.country_code) && this.form.country_code !== 'NL'
        this.countryList = await this.$store.dispatch('countryList')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    async submitForm () {
      if (this.submit) { return false }
      if (await this.$refs.form.validate()) {
        try {
          this.submit = true
          const formData = new FormData()
          Object.entries(this.form).forEach(([key, value]) => {
            formData.set(key, value)
          })
          await this.$store.dispatch('company/update', formData)
          this.$store.commit('auth/changeCompany', {
            form: this.form,
            image: this.picImage
          })
          this.$toasted.global.success_message({
            message: this.$t('company.updateSuccess')
          })
        } catch (e) {
          errHandler(e, this.$toasted, key => this.$t(key))
        } finally {
          this.submit = false
        }
      }
    },
    openFilePicker () {
      this.$refs.fileInput.onPickFile()
    },
    clearForm () {
      this.$nextTick(() => {
        this.form = {
          name: '',
          address: '',
          city: '',
          postal_code: '',
          mobile: '',
          logo: '',
          pre_email_body: ''
        }
        this.picImage = ''
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      })
    },
    getUploadedFile (e) {
      this.form.logo = e[0] || ''
      this.changeImage = true
    }
  },
  watch: {
    'form.country_code': function () {
      this.has_vat = isEU(this.form.country_code) && this.form.country_code !== 'NL'
    }
  }
}
</script>
